import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  leaveTypeForEdit: undefined,
  leavePolicyForEdit: undefined,
  leaveForEdit: undefined,
  error: null,
  leaveType: null,
  leavePolicy: null,
  leavePolicyDropdown: null,
  approvers: null,
  employees: null,
  leaveSummery: null,
  employeeDetails: null,
  personByDept: null,
  employee: null,
  myleave: [],
  employeeleave: [],
  offDayMyleave: null,
  encashment: null,
  encashmentDetails: null,
  encashmentSummery: null,
  deductionList: null,
  deductionOne: null,
  docs: [],
  holiday: [],
  weekend: [],
  employeeCategory: null,
  emergencyLeaveForEdit: null,
  workingHrs: [],
  emmergency_leave: [],
  leave_reconcilation: [],
  departmental_leave: [],
  latePolicyForEdit: null,
  leaveDetailsOfEmployee: null,
  leaveInfo: null,
  reconciliationRequestInfo: null,
  tenureLossHistory: [],
  leaveBucket: [],
  leavePolicyAssign: null,
  leaveInfoRejoin: null,
  leaveRejoinForEdit: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const leaveSlice = createSlice({
  name: "leave",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    leavetypeOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveTypeForEdit = action.payload.leaveTypeForEdit;
      state.error = null;
    },

    leavePolicyAssignFetched: (state, action) => {
      state.actionsLoading = false;
      state.leavePolicyAssign = action.payload.leavePolicyAssign;
      state.error = null;
    },

    latePolicyOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.latePolicyForEdit = action.payload.latePolicyForEdit;
      state.error = null;
    },

    emergencyLeaveOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.emergencyLeaveForEdit = action.payload.emergencyLeaveForEdit;
      state.error = null;
    },

    leavePolicyOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.leavePolicyForEdit = action.payload.leavePolicyForEdit;
      state.error = null;
    },

    departmentalLeaveFetched: (state, action) => {
      state.actionsLoading = false;
      state.departmental_leave = action.payload.departmental_leave;
      state.error = null;
    },

    leaveOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveForEdit = action.payload.leaveForEdit;
      state.error = null;
    },

    leaveRejoinOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveRejoinForEdit = action.payload.leaveRejoinForEdit;
      state.error = null;
    },

    servicePeriodFetched: (state, action) => {
      state.actionsLoading = false;
      state.servicePeriod = action.payload.servicePeriod;
      state.error = null;
    },

    tenureLossHistoryFetched: (state, action) => {
      state.actionsLoading = false;
      state.tenureLossHistory = action.payload.tenureLossHistory;
      state.error = null;
    },

    reconciliationRequestOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.reconciliationRequestInfo =
        action.payload.reconciliationRequestInfo;
      state.error = null;
    },

    leaveDeductionFetched: (state, action) => {
      state.actionsLoading = false;
      state.deductionList = action.payload.deductionList;
      state.error = null;
    },

    leaveDocFetched: (state, action) => {
      state.actionsLoading = false;
      state.docs = action.payload.docs;
      state.error = null;
    },

    leaveDeductionOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.deductionOne = action.payload.deductionOne;
      state.error = null;
    },

    leaveTypeFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveType = action.payload.leaveType;
      state.error = null;
    },

    leaveBucketFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveBucket = action.payload.leaveBucket;
      state.error = null;
    },

    employeeListFetched: (state, action) => {
      state.actionsLoading = false;
      state.employee = action.payload.employee;
      state.error = null;
    },

    leaveSummeryFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveSummery = action.payload.leaveSummery;
      state.error = null;
    },

    encashmentSummeryFetched: (state, action) => {
      state.actionsLoading = false;
      state.encashmentSummery = action.payload.encashmentSummery;
      state.error = null;
    },

    getEmployeeOneFetched: (state, action) => {
      state.actionsLoading = false;
      state.employeeDetails = action.payload.employeeDetails;
      state.error = null;
    },

    leaveFetched: (state, action) => {
      state.actionsLoading = false;
      state.myleave = action.payload.myleave;
      state.error = null;
    },

    employeeLeaveFetched: (state, action) => {
      state.actionsLoading = false;
      state.employeeleave = action.payload.employeeleave;
      state.error = null;
    },

    leaveReconcilationFetched: (state, action) => {
      state.actionsLoading = false;
      state.leave_reconcilation = action.payload.leave_reconcilation;
      state.error = null;
    },

    emmergencyLeaveFetched: (state, action) => {
      state.actionsLoading = false;
      state.emmergency_leave = action.payload.emmergency_leave;
      state.error = null;
    },

    OffDayLeaveFetched: (state, action) => {
      state.actionsLoading = false;
      state.offDayMyleave = action.payload.offDayMyleave;
      state.error = null;
    },

    encashmentFetched: (state, action) => {
      state.actionsLoading = false;
      state.encashment = action.payload.encashment;
      state.error = null;
    },

    encashmentDetailsFetched: (state, action) => {
      state.actionsLoading = false;
      state.encashmentDetails = action.payload.encashmentDetails;
      state.error = null;
    },

    personByDeptFetched: (state, action) => {
      state.actionsLoading = false;
      state.personByDept = action.payload.personByDept;
      state.error = null;
    },

    startCallEmployeeLeaveInfo: (state) => {
      state.actionsLoading = true;
      state.leaveSummery = null;
      state.error = null;
    },

    employeeLeaveInfoFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveSummery = action.payload.leaveSummery;
      state.error = null;
    },

    rejoinLeaveInfoFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveInfoRejoin = action.payload.leaveInfoRejoin;
      state.error = null;
    },

    leavePolicyFetched: (state, action) => {
      state.actionsLoading = false;
      state.leavePolicy = action.payload.leavePolicy;
      state.error = null;
    },

    leavePolicyDropdownFetched: (state, action) => {
      state.actionsLoading = false;
      state.leavePolicyDropdown = action.payload.leavePolicyDropdown;
      state.error = null;
    },

    leaveDetailsOfEmployeeFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveDetailsOfEmployee = action.payload.leaveDetailsOfEmployee;
      state.error = null;
    },

    holidayWeekendFetched: (state, action) => {
      state.actionsLoading = false;
      state.holiday = action.payload.holiday;
      state.weekend = action.payload.weekend;
      state.error = null;
    },

    approversFetched: (state, action) => {
      state.actionsLoading = false;
      state.approvers = action.payload.approvers;
      state.error = null;
    },
    employeesFetched: (state, action) => {
      state.actionsLoading = false;
      state.employees = action.payload.employees;
      state.error = null;
    },
    employeeCategoryFetched: (state, action) => {
      state.actionsLoading = false;
      state.employeeCategory = action.payload.employeeCategory;
      state.error = null;
    },
    workingHrsFetched: (state, action) => {
      state.actionsLoading = false;
      state.workingHrs = action.payload.workingHrs;
      state.error = null;
    },
    studyLeaveSettingListFetched: (state, action) => {
      state.actionsLoading = false;
      state.studyLeaveSettingList = action.payload.studyLeaveSettingList;
      state.error = null;
    },
    studyLeaveSettingsFetched: (state, action) => {
      state.actionsLoading = false;
      state.studyLeaveSettings = action.payload.studyLeaveSettings;
      state.error = null;
    },
    AllStudyLeaves: (state, action) => {
      state.actionsLoading = false;
      state.hrms_study_leave = action.payload.hrms_study_leave;
      state.totalItems = action.payload.totalItems;
      state.error = null;
    },
    dropDownStudyLeaveSettingsFetched: (state, action) => {
      state.actionsLoading = false;
      state.dropDownStudyLeaveSettings =
        action.payload.dropDownStudyLeaveSettings;
      state.error = null;
    },
    eligibilityFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveData = action.payload.leaveData;
      state.activeDisciplineRecord = action.payload.activeDisciplineRecord;
      state.isConfirmedFaculty = action.payload.isConfirmedFaculty;
      state.isFullTimeFaculty = action.payload.isFullTimeFaculty;
      state.isValidServiceDuration = action.payload.isValidServiceDuration;
      state.error = null;
    },
    bySlugFetched: (state, action) => {
      state.actionsLoading = false;
      state.by_slug = action.payload.by_slug;
      state.error = null;
    },

    studyLeaveByUserFetched: (state, action) => {
      state.actionsLoading = false;
      state.studyLeaveByUser = action.payload.studyLeaveByUser;
      state.error = null;
    },
    leaveExtensionByUserFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveExtensionByUser = action.payload.leaveExtensionByUser;
      state.error = null;
    },
    leaveExtensionListFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveExtensionList = action.payload.leaveExtensionList;
      state.error = null;
    },
    leaveRejoinListFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveRejoinList = action.payload.leaveRejoinList;
      state.error = null;
    },
  },
});
